import { REDUCER } from '../reducers/reducersConst';

/**
 * LIBRARY REDUCER
 */
let defaultLibraryState = {
  closedFilters: [],
  primaryBooks: [],
  filteredBooks: [],
  currentFilters: {},
  filters: [],
  tags: [],
  isFetching: false,
  isFetchingPreview: false,
  previewBook: undefined,
  importReveal: null,
  importVinculationReveal: null,
  importIsFetching: null,
  importFinishedReveal: false,
  importBookError: undefined,
  selectedUnitId: undefined,
  creatingUnit: null,
  paginator: { page: 0, total: 1 }
};

export let library = (state = defaultLibraryState, action) => {
  switch (action.type) {
    case REDUCER.LIBRARY.SET_CLOSED_FILTERS:
      return {
        ...state,
        closedFilters: action.closedFilters
      };
    case REDUCER.LIBRARY.SET_FETCHING_PREVIEW:
      return {
        ...state,
        isFetchingPreview: action.isFetchingPreview
      };
    case REDUCER.LIBRARY.SET_PRIMARY_BOOKS:
      return {
        ...state,
        primaryBooks: [...action.primaryBooks]
      };
    case REDUCER.LIBRARY.REQUEST_FILTERED_BOOKS:
      return {
        ...state,
        isFetching: true
      };
    case REDUCER.LIBRARY.SET_FILTERED_BOOKS:
      return {
        ...state,
        isFetching: false,
        filteredBooks: [...action.filteredBooks]
      };
    case REDUCER.LIBRARY.SET_CURRENT_FILTERS:
      return {
        ...state,
        currentFilters: action.currentFilters
      };
    case REDUCER.LIBRARY.SET_FILTERS:
      return {
        ...state,
        filters: action.filters
      };
    case REDUCER.LIBRARY.SET_OPEN_PREVIEW:
      return {
        ...state,
        previewBook: action.previewBook,
        creatingUnit: action.creatingUnit
      };
    case REDUCER.LIBRARY.SET_IMPORT_REVEAL:
      return {
        ...state,
        importReveal: action.importReveal,
        creatingUnit: action.creatingUnit
      };
    case REDUCER.LIBRARY.SET_IMPORT_VINCULATION_REVEAL:
      return {
        ...state,
        importVinculationReveal: action.importVinculationReveal
      };
    case REDUCER.LIBRARY.SET_IMPORT_IS_FETCHING:
      return {
        ...state,
        importIsFetching: action.importIsFetching
      };
    case REDUCER.LIBRARY.SET_IMPORT_FINISHED_REVEAL:
      return {
        ...state,
        importFinishedReveal: action.importFinishedReveal
      };
    case REDUCER.LIBRARY.SET_PAGINATOR:
      return {
        ...state,
        paginator: Object.assign({}, action.paginator)
      };
    case REDUCER.LIBRARY.REMOVE_TAG:
      return {
        ...state,
        tags: state.tags.filter(tag => action.tag !== tag)
      };
    case REDUCER.LIBRARY.REMOVE_TAGS:
      return {
        ...state,
        tags: action.tags
      };
    case REDUCER.LIBRARY.ADD_TAG:
      return {
        ...state,
        tags: [...state.tags, action.tag]
      };
    case REDUCER.LIBRARY.REMOVE_SEARCH_CONFIG:
      return {
        ...state,
        tags: [],
        currentFilters: {}
      };
    case REDUCER.LIBRARY.ADD_UNIT_ID:
      return {
        ...state,
        selectedUnitId: action.unitId
      };
    case REDUCER.LIBRARY.REMOVE_UNIT_ID:
      return {
        ...state,
        selectedUnitId: undefined
      };
    case REDUCER.LIBRARY.REMOVE_ALL_UNIT_ID:
      return {
        ...state,
        selectedUnitId: undefined
      };
    default:
      return state;
  }
};
